<template>
    <div>
        
        <el-dialog title="申请试用" :visible.sync="dialogVisible" width="30%" center 
        :close-on-click-moda="false" 
        @close="closeDialog">
        <div style="display:flex;justify-content: center;">
          <div style="float:left;padding-right: 10px;
          height: 50px;
          display: flex;
          align-items: center;">
            <img :src="data.pictureUrl" class="" />
          </div>
          <div style="float:left;height: 50px;display: flex;align-items: center;">
            <div>
              <div class="gg-title">{{data.name}}</div>
              <p class="gg-txt fs-12" v-if="data.description">{{data.description}}</p>
            </div>
            <!-- <div>
              <div v-for="b in data.button" :key="b.id" class="button1">
                <el-button type="primary" round
                style="transform: scale(0.8); font-size: 6px;padding:4px;" @click="advLink(data)">{{b.text}}</el-button>
                
              </div>
            </div> -->
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="closeDialog">取 消</el-button>
          <el-button type="primary" @click="advLink(data)">确 定</el-button>
        </span>

        </el-dialog>

    </div>
</template>

<script>

//API
import { sysProductList,productClue } from '../../api/basisMG'
// 导出模块
export default {
  // 模块数据
  data() {
    //数据  
    return {
      visible: false,
      dialogVisible: false,
      data: {}
    };
  },
  
  props: {
    visibleC: Boolean,
    id: Number
  },
  // 监听指定值，只有指定值变化，才会触发
  watch: {
    'visibleC':{
        handler(val1,val2){
            this.dialogVisible = val1
            if(this.dialogVisible){
                this.getData()
            }else{
                
            }
        },
        deep: true,
        immediate:true
    }
  },
  // 里面的函数只有调用才会执行（实时计算）里面是定义的方法
  methods: {
    
    // 获取产品
    getData() {
        sysProductList({"id": this.id,"page": 1,"pageSize": 1}).then(res=>{
          if(res.code===0){
            this.data = res.data[0]
            this.dialogVisible = true
          }
          
        })
    },
    closeDialog(){
      //清除cookie
      this.$emit('closeDialog',false)
    },

    advLink(obj){
      let params = {
        customersNeed: '申请试用产品：'+obj.name,
        url: window.location.host,
        productId: obj.id
      }
      productClue(params).then(res=>{
        if(res.code==0){
          this.$message.success('已提交申请，稍后客户经理会与您联系')
          this.closeDialog()
        }else{
          this.$message.error(res.message)
        }
      })
    },

  },
  // 创建前状态(里面是操作)
  beforeCreate() {},
  // 创建完毕状态(里面是操作)
  created() {
    
  },
  // 挂载前状态(里面是操作)
  beforeMount() {},
  // 挂载结束状态(里面是操作)
  mounted() {},
  // 更新前状态(里面是操作)
  beforeUpdate() {},
  // 更新完成状态(里面是操作)
  updated() {},
  // 销毁前状态(里面是操作)
  beforeDestroy() {},
  // 销毁完成状态(里面是操作)
  destroyed() {}
};
</script>
// scoped 样式只在本组件使用
<style scoped>

.qrcode_login_rl_bg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
}
.qrcode_login_rl_mask {
    width: 260px;
    height: 260px;
    position: absolute;
    top: 55px;
    left: 52%;
    margin-left: -143px;
    background: rgba(255, 255, 255, .9);
}
.qrcode_login_rl_info {
    position: absolute;
    top: 163px;
    width: 100%;
    text-align: center;
    z-index: 2;
    font-size: 14px;
}

.bdwxsm {
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/clue/clueDialog.vue